<template>
  <el-select
    v-model="carSizeId"
    placeholder="请选择"
    @visible-change="server"
    @change="handleCarSize">
    <el-option
      v-for="(item, index) in carSizeTable"
      :key="index"
      :value="item.Id"
      :label="item.Name"
    >
    </el-option>
  </el-select>
</template>

<script>
// import park from '../'
import { billCarSize } from "@/api/module/tenant";

export default {
  data() {
    return {
      carSizeId: null,
      carSizeTable: [],
    };
  },
  props: {
    value: [String, Number],
  },
  mounted() {
  },
  methods: {
    async server (bool) {
      if (bool) {
        let res = await billCarSize();
        if (res.state === "success") {
          this.carSizeTable = res.data;
          this.carSizeId = this.value;
          // this.handleCarSize(this.value)
        } else {
          this.$message.error(res.message);
        }
      }
    },
    handleCarSize(value) {
      // this.$emit("input", value);
      this.$emit("change", {value: Number(value), key: 'carSize'});
    },
  },
};
</script>

<style>
</style>
